import { Check } from 'lucide-react';
import { cn } from '../../lib/utils';
import { STEPS } from './tripConstants';

export const StepProgressBar = ({ currentStep }) => (
  <div className="mb-6 bg-white/10 backdrop-blur-md rounded-2xl p-3 border border-white/20">
    <div className="flex items-center justify-between relative">
      <div className="absolute left-0 right-0 top-5 h-1 bg-white/20 -z-10 rounded-full" />
      <div className="absolute left-0 top-5 h-1 bg-gold -z-10 rounded-full transition-all duration-500 shadow-lg"
        style={{ width: `${((currentStep - 1) / (STEPS.length - 1)) * 100}%` }} />
      
      {STEPS.map((step) => {
        const StepIcon = step.icon;
        const isCompleted = currentStep > step.id;
        const isCurrent = currentStep === step.id;
        
        return (
          <div key={step.id} className="flex flex-col items-center" data-testid={`step-${step.id}`}>
            <div className={cn('w-10 h-10 rounded-full flex items-center justify-center transition-all duration-300',
                isCompleted && 'bg-gold text-ocean shadow-lg',
                isCurrent && 'bg-white text-ocean shadow-lg ring-4 ring-offset-2 ring-white/30',
                !isCompleted && !isCurrent && 'bg-white/20 text-white/60')}>
              {isCompleted ? <Check className="w-5 h-5" /> : <StepIcon className="w-5 h-5" />}
            </div>
            <span className={cn('hidden md:block text-xs mt-2 font-medium transition-colors',
              isCurrent ? 'text-white' : isCompleted ? 'text-gold' : 'text-white/50')}>
              {step.title}
            </span>
          </div>
        );
      })}
    </div>
  </div>
);
